import React from 'react'
import {
  Paper,
  Table,
  TableHead,
  TableCell,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import ListAltIcon from '@material-ui/icons/ListAlt'
import StoreIcon from '@material-ui/icons/Store'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.fadedGreen.main,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2, 2, 1),
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.fadedGreen.light,
    },
  },
  name: {
    color: theme.palette.orange.main,
    fontSize: '1.25rem',
    fontFamily: 'Gotham',
    lineHeight: 1.1,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      lineHeight: 1.5,
    },
  },
  firstColumn: {
    width: '250px',
  },
  inlineInfo: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      marginRight: theme.spacing(1),
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
}))

const InventoryLocationCard = ({ location }) => {
  const classes = useStyles()

  return (
    <Paper className={classes.root} elevation={0}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.firstColumn}>
              <Typography className={classes.name}>{location.name}</Typography>
              <div className={classes.inlineInfo}>
                <IconButton size="small">
                  <ListAltIcon />
                </IconButton>
                <Typography>Number of Items:</Typography>
                <Typography>{location.numberOfItems}</Typography>
              </div>
              <div className={classes.inlineInfo}>
                <IconButton size="small">
                  <StoreIcon />
                </IconButton>
                <Typography>Current Stock: </Typography>
                <Typography>{location.currentStock}</Typography>
              </div>
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
      </Table>
    </Paper>
  )
}

InventoryLocationCard.propTypes = {
  location: PropTypes.shape({
    name: PropTypes.string.isRequired,
    numberOfItems: PropTypes.number,
    currentStock: PropTypes.number,
  }).isRequired,
}

export default InventoryLocationCard
